import { render } from "./ShoporderForm.vue?vue&type=template&id=bfc1e26a&scoped=true"
import script from "./ShoporderForm.vue?vue&type=script&lang=js"
export * from "./ShoporderForm.vue?vue&type=script&lang=js"

import "./ShoporderForm.vue?vue&type=style&index=0&id=bfc1e26a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfc1e26a"]])

export default __exports__